import React, { useEffect, useState } from 'react';
import { Stack, Grid} from '@mui/material';
import Brightness1Icon from '@mui/icons-material/Brightness1';

const PlainSeatLayout = ({layout=[]}) => {

  const [seatLayoutData, setSeatLayoutData] = useState([]);

  const buildSeatLayout = (seatNumbers = []) => {
    const noOfColumGroup = 2;
    const seatsPerColumn = 2;
    const noOfColums = noOfColumGroup * seatsPerColumn;
    const noOfRows = Math.ceil(seatNumbers.length / noOfColums);
    const data = [];

    for(let row=0; row < noOfRows; row++) {
      const arrayIndex = row*noOfColums;
      const rowData = seatNumbers.slice(arrayIndex,arrayIndex+noOfColums);
      // const columnsPerRow = Math.ceil(rowData.length/seatsPerColumn);
      const finalRowData = [];
      // seat column 
      for(let c = 0; c < noOfColumGroup; c++) {
        const columnIndex = c*seatsPerColumn;
        const columnSeatData = rowData.slice(columnIndex,columnIndex+seatsPerColumn);
          finalRowData.push([...columnSeatData]);
        }
      data.push([...finalRowData]);
    }
    return data;
  }

  useEffect(() => {
    const x = buildSeatLayout(layout);
    setSeatLayoutData([...x]);
  }, [layout]);



  function buildSeatSourceUrl(seat) {
    let url = '/assets/images/desk-chair-black.svg';
    if(seat.booked) {
      url = '/assets/images/desk-chair.svg';
    }
    // if(selectedSeats.includes(seat.id)) {
    //   url = '/assets/images/desk-chair-yellow.svg';
    // }
    return url;
  }

  return (
    <Grid container columnSpacing={4} rowSpacing={2} >
      <Grid container item xs={12} sm={12} lg={12} md={12} rowSpacing={2} columnSpacing={0} direction="row"  alignItems="center" justifyContent="flex-start">
        <Grid item xs={12} sx={{mb:1}}>
          <Stack spacing={2} direction="row">
            <Brightness1Icon sx={{color: "#000"}} /> Available
            <Brightness1Icon sx={{color: "#AAB1BA"}} /> Booked
            {/* {availableSeats ? <><Brightness1Icon color="primary" /> Selected</> : null} */}
          </Stack>
        </Grid>
        {seatLayoutData.map((row, i) => {
          return (
            <Grid key={i} container item xs={12} sm={12} lg={12} md={12} sx={{mb: (i+1)%3 === 0 ? 4 : 0}} columnSpacing={12} direction="row"  alignItems="center" justifyContent="center">
              {row.map((column, j) => (
                <Grid key={j} container item xs={6} sm={5} xl={3} lg={3} md={3} columnSpacing={3}  alignItems="center" justifyContent="center">
                  {column.map((seat, index) => (
                    <Grid item xs={6} sm={6} xl={6} lg={6} md={6} sx={{textAlign: 'center'}} key={index}>
                      <img
                        style={{width: '30px', height: '30px', padding: '2px', cursor: 'initial' }}
                        src={buildSeatSourceUrl(seat)}
                        alt={`Seat ${seat.name}`}
                      />
                      <p style={{margin: '0 0 8px 0'}}>
                        {seat.name}
                      </p>
                    </Grid>
                  ))}
                </Grid>
              ))}
            </Grid>
          )
        })}
      </Grid>
    </Grid>
  );
}
 
export default React.memo(PlainSeatLayout);
